import { pick } from "lodash-es";
import { SharedApiV2 } from "@capstone/mock-api";
import { SiteUpdate } from "./site-update.model";
import { Site } from "./site.model";

export class SiteAppointmentsSettingsUpdate {
  public constructor(private readonly update: SiteUpdate) {}

  public get base(): Site | null {
    return this.update.base;
  }

  public serialize(): SharedApiV2.PatchAppointmentsSiteDto {
    return pick(this.update.serialize(), [
      "advancedScheduling",
      "allowAdditionalPOs",
      "allowApptOrdersDiffDock",
      "allowBackdatedAppointments",
      "allowBackdatedPurchaseOrders",
      "allowDuplicateOrders",
      "allowManualOrders",
      "allowOrderCloning",
      "allowReschedulingOfVendorSameDayAppointment",
      "appointmentInterval",
      "appointmentMessaging",
      "appointmentPalletOverride",
      "appointmentStartOptions",
      "apptCancelLimit",
      "apptDetailsOrdersColumnOptions",
      "apptModifyOrdersColumnOptions",
      "captureAppointmentContactInformation",
      "captureApptIntermodal",
      "captureApptLoadType",
      "captureApptLoadWeight",
      "captureOrderEntryDate",
      "captureOriginTypeB",
      "captureOriginTypeC",
      "captureOriginTypeL",
      "captureOriginTypeT",
      "capturePoQuantities",
      "carrierETA",
      "customMPUCalcBuffer",
      "customMPUCalcEnd",
      "customMPUCalcStart",
      "defaultDoorGroup",
      "enableSearchByMasterPO",
      "enableSearchPOByClientAppointmentNumber",
      "gatePassMessage",
      "goDoFeature",
      "guidedFlowUnloaderDescription",
      "maxAppointmentDuration",
      "maxCalcMinutesPerUnit",
      "maximumReservationTimeSlots",
      "minimumUnloadMinutes",
      "minutesPerUnit",
      "offComplexFeature",
      "onComplexFeature",
      "restrictPOPalletandCaseCaptureGuided",
      "restrictPartnerSelectionOnUnloader",
      "scheduleAppointmentHoverOptions",
      "scheduleAppointmentSelectionOptions",
      "scheduleDisplayDoorGrouping",
      "scheduleLabelApptField",
      "unrestrictedAppointmentActions",
      "useCustomMPUForApptDuration",
      "wksAvgUnloadTime",
    ]);
  }
}
